let fallbackCounter = 0;

function uuidFromRandomValues(cryptoApi: Crypto): string {
  const bytes = new Uint8Array(16);
  cryptoApi.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function createClientId(prefix?: string): string {
  const cryptoApi = globalThis.crypto;
  let value: string;

  if (typeof cryptoApi?.randomUUID === "function") {
    value = cryptoApi.randomUUID();
  } else if (typeof cryptoApi?.getRandomValues === "function") {
    value = uuidFromRandomValues(cryptoApi);
  } else {
    fallbackCounter += 1;
    const timestamp = Date.now().toString(36);
    const counter = fallbackCounter.toString(36);
    const pseudoRandom = Math.random().toString(36).slice(2, 12);
    value = `${timestamp}-${counter}-${pseudoRandom}`;
  }

  return prefix ? `${prefix}-${value}` : value;
}

